import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { SidebarProvider } from './context/SidebarContext';
import { PageSessionProvider } from './context/PageSessionContext';
import './api/authInterceptor';
import App from './App';
import './api/authInterceptor';

// Primereact CSS
import 'primereact/resources/themes/lara-light-blue/theme.css'; // or other theme
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

// Bootstrap & Global CSS
import './assets/styles/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'; // Optional if you plan to use Bootstrap Icons
import './assets/styles/global.css'; // Optional: for your global custom styles

//import './assets/styles/app.min.css';
import 'remixicon/fonts/remixicon.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <PageSessionProvider>
        <BrowserRouter>
          <SidebarProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </SidebarProvider>
        </BrowserRouter>
      </PageSessionProvider>
    </HelmetProvider>
  </React.StrictMode>
);
